import { toast } from 'react-toastify';

export const showToast = (message, type = 'default') => {
  const toastOptions = {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'mx-2 sm:mx-0 rounded-lg shadow-lg top-10 mt-2',
    bodyClassName: 'font-medium pl-3 text-white',
  };

  const toastTypes = {
    success: 'bg-green-600',
    error: 'bg-red-600',
    info: 'bg-blue-600',
    warning: 'bg-yellow-600',
    default: 'bg-gray-600'
  };

  const toastFunction = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warn,
    default: toast
  };

  toastOptions.className += ` ${toastTypes[type]}`;
  toastFunction[type](message, toastOptions);
}
